import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/dymaczew/Documents/_code/mcm/cp4mcm-demohub/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Follow the steps below to request your CP4MCM ROKS environment.`}</p>
    <h2>{`Requesting a ROKS Cluster`}</h2>
    <p>{`1.Access the `}<a parentName="p" {...{
        "href": "https://dte2.us1a.cirrus.ibm.com/"
      }}>{`DTE 2.0 site`}</a>{` and log in using your IBM credentials.`}</p>
    <p>{`2.On the home page, scroll down and open the `}<strong parentName="p">{`Cloud Pak for Multicloud Management Activation Kit`}</strong>{`.`}</p>
    <p>{`  `}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "58.68055555555556%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAADHElEQVQoz12SbUzTVxSHb5bNLVthYbTodAtxk8A6McIiiMmcc8uExU4llBYTgzFzJPtiosnSjWQJfNBIgwVZlwUiMqG2vCwuGpeouMinzZnsw6DIyBBEKn2zpUVe/Lfw7N6/8Ys3eXJy7u+e3zn35oqvDtdi/cKiY9u/D/uB/Vgte6ms2IPdbsdaU4OtuhqbzSaxU1VVidVaRbXtILaDh7HV1OrYDx2VHEG0t7bw5rp1FJrNmAvyKcjbxLbSMioOVFP+QRGW7aUUFRVRXFzMVhkrPq/ko08srH2vgjzLOXJ3fc87u09RVg8f/7KION3YgBCCrKwsMjIzycjIIOetXMzbP8S81sQGo1HXjEYT2dlGNr1fSm5BCeLFjYiNdQhTOcL4KS+YT5J95BZi+M5fnOvsxNPTg9frxefz6fR5ZN59ga7ubrwXL9LX309//wB9vT56pd5+vpcOz3U6vVfp8l6hy/cbnku3EUvxGMFwmHg8zsLCAslkkqXlZdSKzc4yEwgQDAYJyzOKVCqla5FwkNDsDNFIkHgsSiL+iNX0EiIui/4dH2diYoLp6WmdBzMzJGIxApP3mJyaYkqi9kOhEDG5r5r7R0cZHh7B7/dzd2yMkRG/rAsgHkcjhCMR2SXG3NwcCcn8/DyPEwki0lhpUUlExWhUN1S6ylUDFRPyrELdTiTDIQJySv1KUnwkC5KyICmNg/enCDx8yOwzXTInp1NNlZkyUDwzVAgtkUR7kmJFe8JqSkWNlCbj8iKJcJSFxUXSKU1/t3R6BW0FltOraNrTt3x+iaHBQb45dozG+nrONrvwdHbgbXfT3ubm7vg9Rsf+4/LVQS70DPD70BB/Xxvg9qUenM0tnHWdwdXcjNPppMXlwu12IxoaG/V/qDCZcthRUsa+nTtwnHAw+Oc//Hr5BvUNTZxq7cB52oGv7WtOOmoRL61h2xpBecG77PpsD4WbN2MwGBBNTU26meE1A6+/kc36rBxKSnbzpaOFO/5Jbt76gx87fuantlaOf/cD56/UUfftIV55OZNMw6u8vWE9hVu2kJ+fLwcy8T9FZqdVvnfx1AAAAABJRU5ErkJggg==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "cp4mcm ak",
          "title": "cp4mcm ak",
          "src": "/cp4mcm-demohub/static/396af43e7df9cb51331b0390225823c8/3cbba/cp4mcm-ak.png",
          "srcSet": ["/cp4mcm-demohub/static/396af43e7df9cb51331b0390225823c8/7fc1e/cp4mcm-ak.png 288w", "/cp4mcm-demohub/static/396af43e7df9cb51331b0390225823c8/a5df1/cp4mcm-ak.png 576w", "/cp4mcm-demohub/static/396af43e7df9cb51331b0390225823c8/3cbba/cp4mcm-ak.png 1152w", "/cp4mcm-demohub/static/396af43e7df9cb51331b0390225823c8/257b3/cp4mcm-ak.png 1402w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span></p>
    <p>{`3.Open the `}<strong parentName="p">{`Environments`}</strong>{` tab.`}</p>
    <p>{`  `}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "57.98611111111111%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABv0lEQVQoz52Ra0/iUBCGD4tcrLSlF8rFEBY++g/01+7GNSRFKHj5rr9kPyBLAVsoLZBQ4N0zx2A0wWhs8mTmzJl5Z+aUlctlmKYJQzdgWRZ0XRdnTdOET1aWZYGiKAfJ5/Mij2C1Wg2VSgWGYYgLEnsLNSFbLBZFDkGNCoXCy5n72WwWiUQCP5JHYI1GA6VSCSRMRYoiv05GliYgUcrZT0JxiwvKqopy5RS5XA7JZBJHqRTYxcU56vWffCUFulGAompChASouFqtCgEqyGQySKfTAsanqasK6rxZRjqBdHwMSZLA1LyJWuMMmnkKxhIc9ikpTppjHbpvtVp4eHjE3d09ms0m5wotu4nbmx7a7TY6nQ4cx4Ft2+h2u7jp9eBc/cH171+wLy/R4TGH59A9abHRaITxeAyyk8kEk1mM5RbY7PCtjw1dV4gNh0Nh/7ke/j5N8eTOEAQhoihEHMcH2ByMM8/z4Ps+yE6nU/jeM7znEYKZj80mxnq9xna7Fd13u92nsCAIQJDofD7HcrnEYrEQNowi4YdhKNj7EY/veXumGtbv9zEYDODy1Ver1btJvvWG9ENoOlptL/KV1T7iPzb3heIMNdwvAAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "environments",
          "title": "environments",
          "src": "/cp4mcm-demohub/static/aa15f9f6c0d4c0e82fed73a7fa1c8fa7/3cbba/environments.png",
          "srcSet": ["/cp4mcm-demohub/static/aa15f9f6c0d4c0e82fed73a7fa1c8fa7/7fc1e/environments.png 288w", "/cp4mcm-demohub/static/aa15f9f6c0d4c0e82fed73a7fa1c8fa7/a5df1/environments.png 576w", "/cp4mcm-demohub/static/aa15f9f6c0d4c0e82fed73a7fa1c8fa7/3cbba/environments.png 1152w", "/cp4mcm-demohub/static/aa15f9f6c0d4c0e82fed73a7fa1c8fa7/5d3f2/environments.png 1279w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span></p>
    <p>{`4.Select the ROKS cluster that you want (the simplest way is to select the latest version of the Express instalation).`}</p>
    <p>{`  `}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "43.05555555555555%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAAAsSAAALEgHS3X78AAAB7ElEQVQoz02QSY/aQBCFGxgmZAiYxWCzZQ4jRUJoNNIoipJLDsk1Pz0cAolszGLMYgNeMBiDpRxeqpsZKYdPr6tc9fq1WbPZhCzLglqthkqlgmq1inK5DEmSUCqVhP5PoVBAsVgUtB+6qCktFN7lRc0URUFDVYURN+Rm/KzU62jRZa89lWb4bJUuTqfTuMlmkc1k8PDlGz58/4Hb7A0yVLNerweZlgpSCbdvcpAoUT6fh1SuIE0DfDmVSoExJsjd5ZGiHu/z+ZLaROfpGbm3d6LP3rdaqMtVNOh2lVI1VQUyJeq2W+h22lCobnfu8enzVzw+faSUqkh9pU7JG6jzV7z8Njbo96ENfkEfDqAPBjD+/MZ4OITZ/4nxaITJZILZzIS98WA7LqzFAuPxGJqmCTUMQ+h0OoVpmmDL9Rqu5+FwPCI8HBBfLvibJNg6DkzLwmq1wm63w3a7gUuaJBeEYYj5fI4FmVs0w3VNPnEcg2m6DuvlI2e5XOLg+7Cpx1PoHF0TSTiu68GnAIYxEsk43JQndF0XzNnu4JFBsN/DDwL4pFG4h7PaYGJtMSOm8w3MxY5eEiCKjjR7FOcgoL2A5qMIp9NJwPb0tNCxsbftq3LWS/huiNM5wfl8Ji6ISfmTOFEU03JM/Wv9asb5B0jf06oK07FnAAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "express",
          "title": "express",
          "src": "/cp4mcm-demohub/static/f2017c3c06fa895d553d56c554882ef4/3cbba/express.png",
          "srcSet": ["/cp4mcm-demohub/static/f2017c3c06fa895d553d56c554882ef4/7fc1e/express.png 288w", "/cp4mcm-demohub/static/f2017c3c06fa895d553d56c554882ef4/a5df1/express.png 576w", "/cp4mcm-demohub/static/f2017c3c06fa895d553d56c554882ef4/3cbba/express.png 1152w", "/cp4mcm-demohub/static/f2017c3c06fa895d553d56c554882ef4/ed9db/express.png 1713w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span></p>
    <p>{`5.Follow the `}<strong parentName="p">{`Create a reservation`}</strong>{` form to define the details of your ROKS Reservation.`}</p>
    <p>{`  `}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "55.90277777777778%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAABtElEQVQoz52RTWsTURSGr1ShGzehAUXTNBNbgzRUMlRMLFaoblwV3QguNP6LJk2EtlbRhW5cSKFgqeKmYkt+1WSahmRm8p3He66mDaF+Hng4H/fc9545oxbSaW7czBCPx7Esi8hklKlYjGh0iqsz0yQTcWasSV2PEA6HCU9M6F7dd/kSiViEueQstm2TSqWY1nWVTl7j1uISmYU7hEIh7JTNvdsZ7tpXuD9vsZS8SOLCea7PzTJ+boyzSjF+RjGm/fLiPE8ePyL7LEs2+5SHD5ZRhUKRXL7I+otX5HJ5Pm59YG9nm+13m+y8f83W25dsFAtsrq3xZv05G4VVVldWKObz7H3ZZf/bVw4O9imVSnz+tIviFOtqOv0ffrj2N6Y8z6Ncdjg8dI13y2WNQ/XoiCDw8X3PEAQa/2eu78g93+QnNJtNVKvVMkmj0UDiAZ1Oh263+0/0ej2UiDmOQ6VSOX7lfxgMZCas1+vHxdGmUX4n2G63TwS9U/Yy+HxpFIZXMoqIGkFRrtVq9Pt9swPZndRkJ8M1aZb4j385CAJc1zWiMqmIDSaVWM7lrFqtmlhMHvoV3wFM7OOSrmNcbgAAAABJRU5ErkJggg==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "reservation form",
          "title": "reservation form",
          "src": "/cp4mcm-demohub/static/031427ffa79bf1245d471ab877a59d0b/3cbba/reservation-form.png",
          "srcSet": ["/cp4mcm-demohub/static/031427ffa79bf1245d471ab877a59d0b/7fc1e/reservation-form.png 288w", "/cp4mcm-demohub/static/031427ffa79bf1245d471ab877a59d0b/a5df1/reservation-form.png 576w", "/cp4mcm-demohub/static/031427ffa79bf1245d471ab877a59d0b/3cbba/reservation-form.png 1152w", "/cp4mcm-demohub/static/031427ffa79bf1245d471ab877a59d0b/7ea17/reservation-form.png 1420w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span></p>
    <p>{`  After few minutes, your ROKS environment is ready. Now you are ready to move to the next step and install Cloud Pak for Multicloud Management!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      